import NavigationMenuDemo from "@/components/ui/demo";
import BoxyAppIconsDemo from "@/components/ui/boxy-app-icons-demo";
import { RadialOrbitalTimelineDemo } from "@/components/ui/radial-orbital-timeline-demo";
import { SplineSceneBasic } from "@/components/ui/spline-scene-basic";
import { WovenLightHero } from "@/components/ui/woven-light-hero";
import FloatingIconsHeroDemo from "@/components/floating-icons-hero-demo";
import type { AppCopy, Direction, Language } from "@/lib/i18n";

interface DemoOneProps {
  copy: AppCopy;
  direction: Direction;
  language: Language;
  onLanguageChange: () => void;
}

export default function DemoOne({
  copy,
  direction,
  language,
  onLanguageChange,
}: DemoOneProps) {
  return (
    <>
      <NavigationMenuDemo
        copy={copy.nav}
        language={language}
        onLanguageChange={onLanguageChange}
      />
      <WovenLightHero copy={copy.hero} language={language} />
      <section
        id="about"
        className="scroll-mt-14 bg-gradient-to-b from-slate-50 via-white to-slate-100 px-4 py-20 transition-colors sm:px-6 lg:px-8 dark:from-black dark:via-slate-950 dark:to-black"
      >
        <div className="mx-auto w-full max-w-6xl">
          <SplineSceneBasic copy={copy.spline} direction={direction} />
        </div>
      </section>
      <section
        id="services"
        className="scroll-mt-14 bg-slate-50 px-4 py-16 transition-colors sm:px-6 lg:px-8 dark:bg-slate-950"
      >
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center justify-center gap-10">
          <h2
            className="text-center text-5xl font-semibold leading-tight text-slate-900 drop-shadow-[0_14px_34px_rgba(148,163,184,0.24)] sm:text-6xl dark:text-white"
          >
            {copy.servicesMap.heading}
          </h2>
          <BoxyAppIconsDemo tiles={copy.servicesMap.tiles} />
        </div>
      </section>
      <RadialOrbitalTimelineDemo copy={copy.timeline} direction={direction} />
      <FloatingIconsHeroDemo copy={copy.floating} />
    </>
  );
}
